export default __webpack_public_path__ + "static/media/36.6bd45ba3.jpg";